/* WF-3 · Visual Access Manager API client. */
import api from "@/lib/api";

const H = () => {
  const v = typeof document !== "undefined"
    ? document.cookie.split(";").map((c) => c.trim()).find((c) => c.startsWith("active_hotel_id="))
    : null;
  return v ? { headers: { "X-Hocp-Hotel": decodeURIComponent(v.split("=")[1]) } } : {};
};

export const v3API = {
  modules:       ()          => api.get("/wf/v3/modules", H()).then((r) => r.data),
  getAccess:     (uid)       => api.get(`/wf/v3/access/${uid}`, H()).then((r) => r.data),
  putAccess:     (uid, body) => api.put(`/wf/v3/access/${uid}`, body, H()).then((r) => r.data),
  presetCaps:    (tplId)     => api.get(`/wf/v3/preset/${tplId}/capabilities`, H()).then((r) => r.data),
  copyFrom:      (srcUid)    => api.get(`/wf/v3/copy-from/${srcUid}`, H()).then((r) => r.data),
  matrix:        ()          => api.get("/wf/v3/matrix", H()).then((r) => r.data),
  simulate:      (caps)      => api.post("/wf/v3/simulate", { capabilities: caps }, H()).then((r) => r.data),
  resolveDeps:   (caps)      => api.post("/wf/v3/dependencies/resolve", { capabilities: caps }, H()).then((r) => r.data),
};
